// extracted by mini-css-extract-plugin
export default {"pageWrap":"Vc-z","fullWidth":"Wc-z","heading":"Xc-z","fullBleed":"Yc-z","hidden":"Zc-z"};